import React from "react";
import { useNavigate } from "react-router-dom";

import { Pod24CommonLayout } from "../layouts/Pod24CommonLayout";
import { useSocialLogin } from "../hooks/use-social-login";

export const SignupPage: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useSocialLogin();

  const handleEmailSignup = () => {
    navigate("/signup/email");
  };

  return (
    <Pod24CommonLayout>
      <div className="flex justify-center px-4" style={{ paddingTop: "100px" }}>
        <div className="w-full" style={{ maxWidth: "560px" }}>
          {/* 제목 */}
          <div
            className="text-left"
            style={{ marginBottom: "20px", height: "68px" }}
          >
            <h1
              className="font-['Pretendard'] font-normal text-gray-900"
              style={{ fontSize: "24px" }}
            >
              회원가입 하고
            </h1>
            <h2
              className="font-['Pretendard'] font-semibold text-gray-900"
              style={{ fontSize: "24px" }}
            >
              서비스를 이용하세요.
            </h2>
          </div>

          {/* 구분선 */}
          <div
            className="w-full border-t border-gray-300"
            style={{ marginBottom: "20px" }}
          ></div>

          {/* SNS 회원가입 버튼들 */}
          <div style={{ marginBottom: "32px" }}>
            {/* 네이버 */}
            <button
              onClick={() => {
                login("naver");
              }}
              className="w-full transition-colors hover:opacity-90"
            >
              <img
                src="/assets/icons/naver.svg"
                alt="네이버로 시작하기"
                className="h-[48px] w-full object-cover rounded-[8px]"
              />
            </button>

            {/* 카카오 */}
            <button
              onClick={() => {
                login("kakao");
              }}
              className="w-full transition-colors hover:opacity-90 mb-2"
            >
              <img
                src="/assets/icons/kakao.svg"
                alt="카카오로 시작하기"
                className="h-[48px] w-full object-cover rounded-[8px]"
              />
            </button>

            {/* 구글 */}
            <button
              onClick={() => {
                login("google");
              }}
              className="w-full transition-colors hover:opacity-90"
            >
              <img
                src="/assets/icons/google.svg"
                alt="구글로 시작하기"
                className="h-[48px] outline outline-gray-300 w-full object-cover rounded-[8px]"
              />
            </button>
          </div>

          {/* 구분선 */}
          <div className="flex items-center" style={{ marginBottom: "32px" }}>
            <div className="flex-1 border-t border-gray-300"></div>
            <span
              className="px-4 text-gray-500 font-['Pretendard'] font-medium"
              style={{ fontSize: "14px" }}
            >
              또는
            </span>
            <div className="flex-1 border-t border-gray-300"></div>
          </div>

          {/* 이메일로 가입하기 버튼 */}
          <button
            onClick={handleEmailSignup}
            className="h-[48px] w-full font-['Pretendard'] font-medium transition-colors hover:opacity-90"
            style={{
              fontSize: "16px",
              color: "#4285F4",
              borderRadius: "8px",
              border: "2px solid #4285F4",
              backgroundColor: "transparent",
              marginBottom: "221px",
            }}
          >
            이메일로 가입하기
          </button>
        </div>
      </div>
    </Pod24CommonLayout>
  );
};
